var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPromoTagFill(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.9316 2.33789C11.1605 2.36057 11.3759 2.46203 11.54 2.62598L18.2793 9.36523C19.2486 10.3403 19.2486 11.9156 18.2793 12.8906L18.2773 12.8926L12.8994 18.2686C12.4306 18.7379 11.7952 19.0028 11.1318 19.0029C10.4688 19.0028 9.83205 18.7393 9.36328 18.2705L2.62598 11.54C2.43865 11.3525 2.33301 11.0981 2.33301 10.833V3.33301C2.33318 2.78098 2.78098 2.33318 3.33301 2.33301H10.833L10.9316 2.33789ZM7.70801 6.66699C7.13297 6.66717 6.66717 7.13297 6.66699 7.70801C6.66699 8.28319 7.13287 8.74982 7.70801 8.75C8.2833 8.75 8.75 8.2833 8.75 7.70801C8.74982 7.13287 8.28319 6.66699 7.70801 6.66699Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPromoTagFill);
export default __webpack_public_path__ + "static/media/promo-tag-fill.5b6bdc17903fb3fadb92620b04cbfc7e.svg";
export { ForwardRef as ReactComponent };